import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { z } from 'zod';
import { createPredicateSchema } from '@/entities/predicate';
import { UserGroupFromValues } from './types';

const createSchema = (t: TFunction<readonly ['common']>) => {
  return z.object({
    name: z.string().min(1, t('common:required')),
    predicate: createPredicateSchema(t('common:predicateHasIssues')).refine((value) => !!value.dsl, {
      error: t('common:required'),
    }),
    // Схема разбора задаёт и то, что доедет до сабмита: поля состава, не описанные здесь, будут отброшены
    users: z
      .array(
        z.object({
          id: z.number(),
          firstName: z.string(),
          middleName: z.string().nullish(),
          lastName: z.string(),
          email: z.string(),
          role: z.object({ code: z.string(), name: z.string() }).nullish(),
          isActive: z.boolean(),
        }),
      )
      .optional()
      .default([]),
  }) satisfies z.ZodType<UserGroupFromValues>;
};

export const useUserGroupSchema = () => {
  const { t } = useTranslation(['common']);

  return createSchema(t);
};
